<template>
 
</template>

<script>

export default {
  title: "New",
  access_code: "L_FORM03",
  created() {
      this.$router.push("/FORMS/LeaveForm/request")
  }
};
</script>

<style>
</style>